import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { RequestListagem, RequestOptionsType, useRequestListagem } from 'hooks/useRequestListagem';
import { LojaImportacao } from 'pages/cadastro/loja-importacao/types';

export function useQueryImportacoes() {
    const requestListagem = useRequestListagem();
    const { page, sort, limit } = useListagemContext();

    const requestOptions: RequestOptionsType = {
        url: '/gestao/lojaconfiguracaoimportacao',
        sort: sort?.length ? sort : [{ property: 'dhInclusao', direction: 'DESC' }],
        limit,
        page,
    };

    return useQuery<RequestListagem<LojaImportacao[]>>({
        queryKey: ['queryImportacoes', requestOptions],
        queryFn: () => requestListagem(requestOptions).then((res) => res.data),
    });
}
